import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Field } from 'redux-form'
import { Button } from 'semantic-ui-react'
import { IconButton, Collapse, Card, CardHeader, CardContent } from '@material-ui/core'
import { ExpandMore, ExpandLess } from '@material-ui/icons'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { getBPPurchasingOrgs, getBPPurchasingView } from 'ducks/vendorMaintenance'
import { getCurrencies, getPaymentTerms, getPurchasingOrgs, getIncoterms } from 'ducks/options'
import { PurchasingInformationContainer } from './styled'

// import r from 'reactotron-react-js'

const PurchasingInformation = (props) => {
  const { valueForm, change, currencies, incoterms, paymentTerms, purchasingOrgs, vendorPurchasingOrgs, isDisplay=false } = props
  const [showPurchasingInfo, setShowPurchasingInfo] = useState(true)

  useEffect(() => {
    if (!currencies.data.length && !currencies.loading) {
      props.getCurrencies()
    }

    if (!incoterms.data.length && !incoterms.loading) {
      props.getIncoterms()
    }

    if (!paymentTerms.data.length && !paymentTerms.loading) {
      props.getPaymentTerms()
    }

    if (!purchasingOrgs.data.length && !purchasingOrgs.loading) {
      props.getPurchasingOrgs()
    }
  }, [])

  useEffect(() => {
    if (valueForm.vendorCode) {
      props.getBPPurchasingOrgs(valueForm.vendorCode)
    }
  }, [valueForm.vendorCode])

  const canEditPurchasingView = () => {
    return (
      !(['ZDOV', 'ZFOV', 'ZRPT', 'ZOTV'].includes(valueForm.accountGroup)) &&
      (['create', 'change'].includes(valueForm.purpose)) && 
      !isDisplay
    )
  }

  const editableForm = () => {
    // if (valueForm.status !== 0 && valueForm.status !== undefined && valueForm.status !== null) {
    //   return !isDisplay && (valueForm.sn !== undefined && valueForm.sn !== null && valueForm.sn !== '')
    // } else {
      return !isDisplay
    // }
  }

  const canEditPurchasingForm = () => {
    if (valueForm.purpose === 'change') {
      return (valueForm.purchasingViewLoaded && editableForm())
    }

    return (['create', 'change'].includes(valueForm.purpose)) && editableForm()
  }

  const onLoadPurchasingViewSuccess = (data) => {
    const getBoolValue = (value, defaultValue) => {
      return (value !== undefined && value !== null && value !== '') ? value : defaultValue
    }

    change('usePurchasingView', getBoolValue(data.usePurchasingView, false))
    change('orderCurrency', data.orderCurrency || '')
    change('paymentTerms', data.paymentTerms || '')
    change('salePerson', data.salePerson || '')
    change('salePersonTelephone', data.salePersonTelephone || '')
    change('incoterm', data.incoterm || '')
    change('incotermsLocation', data.incotermsLocation || '')
    change('grBasedInvoiceVerification', getBoolValue(data.grBasedInvoiceVerification, false))
    change('purchasingViewLoaded', true)
  }

  const onChangePurchasingOrgPurposeChange = (value) => {
    change('usePurchasingView', false)
    change('orderCurrency', '')
    change('paymentTerms', '')
    change('salePerson', '')
    change('salePersonTelephone', '')
    change('incoterm', '')
    change('incotermsLocation', '')
    change('grBasedInvoiceVerification', false)
    change('purchasingViewLoaded', false)
  }

  const renderPurchasingOrgInputWithLoadButton = (props) => {
    return (
      <div style={{ display: 'flex', flex: 1 }}>
        <FieldInput {...props} />
        {
          isDisplay || valueForm.status === 5 ? null :
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Button 
              color='blue'
              content='Load'
              type='button'
              style={{marginRight: '15px' }}
              disabled={
                (valueForm.purchasingOrg === undefined ||
                valueForm.purchasingOrg === null ||
                valueForm.purchasingOrg === '')
              }
              onClick={() => {
                // Load purchasing view
                props.getBPPurchasingView(valueForm.vendorCode, valueForm.purchasingOrg, onLoadPurchasingViewSuccess)
              }}
            />
          </div>
        }
      </div>
    )
  }

  return (
    <Card style={{ marginTop: '10px' }}>
      <CardHeader 
        title='Purchasing Information'
        action={
          <IconButton aria-label='Expand' onClick={() => setShowPurchasingInfo(!showPurchasingInfo) }>
            {showPurchasingInfo ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        }
      />
      <Collapse in={showPurchasingInfo}>
        <CardContent>
          <PurchasingInformationContainer>
            <div className='rowFields'>
              <Field 
                name='usePurchasingView' 
                label='Use Purchasing View' 
                require 
                editable={
                  canEditPurchasingView() || 
                  (valueForm.purpose === 'change' && (
                    valueForm.status === undefined || 
                    valueForm.status === 0 ||
                    (valueForm.status === 5 && valueForm.sn)
                  ))
                }
                type={type.checkbox} 
                component={FieldInput} 
              />
              {
                valueForm.usePurchasingView ? 
                <Field 
                  name='purchasingOrg' 
                  label='Purchasing Org '  
                  options={purchasingOrgs.data}
                  loading={purchasingOrgs.loading}
                  editable={
                    canEditPurchasingForm() 
                    // && (valueForm.status === undefined || valueForm.status === 0)
                  }
                  type={type.select}
                  require
                  component={FieldInput} /> : null
              }
            </div>
            {
              valueForm.usePurchasingView || valueForm.purpose === 'change' ?
                <React.Fragment>
                  <div className='rowFields'>
                    <Field 
                      name='orderCurrency' 
                      label='Order Currency' 
                      require
                      options={currencies.data}
                      loading={currencies.loading}
                      editable={canEditPurchasingForm()} 
                      type={type.select}
                      component={FieldInput} />
                    <Field 
                      name='paymentTerms' 
                      label='Payment Terms' 
                      require
                      options={paymentTerms.data} 
                      loading={paymentTerms.loading}
                      editable={canEditPurchasingForm()}
                      type={type.select}
                      specialOnChange={(value) => change('accPaymentTerms', value)}
                      component={FieldInput} />
                  </div>
                  <div className='rowFields'>
                    <Field
                      name='salePerson'
                      label='Sale Person'
                      editable={canEditPurchasingForm()}
                      type={type.text}
                      component={FieldInput}
                    />
                    <Field
                      name='salePersonTelephone'
                      label={`Sale Person's Telephone`}
                      editable={canEditPurchasingForm()}
                      type={type.text}
                      component={FieldInput}
                    />
                  </div>
                  <div className='rowFields'>
                    <Field 
                      name='incoterm' 
                      label='Incoterm' 
                      options={incoterms.data} 
                      type={type.select}
                      editable={canEditPurchasingForm()}
                      component={FieldInput} />
                    <Field 
                      name='incotermsLocation' 
                      label='Incoterms Location' 
                      require={valueForm.incoterm !== undefined && 
                                valueForm.incoterm !== null &&
                                valueForm.incoterm !== ''} 
                      editable={canEditPurchasingForm()}
                      type={type.text} 
                      component={FieldInput} />
                  </div>
                  <div className='rowFields'>
                    <Field 
                      name='grBasedInvoiceVerification' 
                      label='GR-Based Invoice Verification'
                      editable={canEditPurchasingForm() && !['ZDOV', 'ZRPT', 'ZOTV'].includes(valueForm.accountGroup) }
                      type={type.checkbox} 
                      component={FieldInput} 
                    />
                  </div>
                </React.Fragment> : null
            }
          </PurchasingInformationContainer>
        </CardContent>
      </Collapse>
    </Card>
  )
}

const mapStateToProps = (state) => {
  return ({
    currencies: state.options.currencies,
    incoterms: state.options.incoterms,
    paymentTerms: state.options.paymentTerms,
    purchasingOrgs: state.options.purchasingOrgs,
    vendorPurchasingOrgs: state.vendorMaintenance.vendorPurchasingOrgs
  })
}
  

const mapDispatchToProps = {
  getCurrencies,
  getIncoterms,
  getPaymentTerms,
  getPurchasingOrgs,
  getBPPurchasingOrgs,
  getBPPurchasingView,
}

export default connect(mapStateToProps, mapDispatchToProps)(PurchasingInformation)